module.exports = __webpack_public_path__ + "media/images/shared/side_menus/icons/signup-f8c73774d5bd46ffd6f9eb6804043157.png";